import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Modal from "@mui/material/Modal";
import { useSelector, useDispatch } from "react-redux";
import { showModal } from "../../store/slice/PrintSlice";
import { IoPrint } from "react-icons/io5";
import { useReactToPrint } from "react-to-print";
import dayjs from "dayjs";
import { Help } from "../../utils";
import RenouvellementContrat from "../../pages/Contrats/RenouvellementContrat";
// import { NumberToLetter } from "@mandarvl/convertir-nombre-lettre";
import { InputTextarea } from "primereact/inputtextarea";
import FactureLoyer from "./Factures/FactureLoyer";
import FactureCaution from "./Factures/FactureCaution";

const ParagrapheSectionFacture = ({ libelle, styleParagraphe }) => {
  return <p className={styleParagraphe ? styleParagraphe : null}>{libelle}</p>;
};

export const SectionFacture = ({
  DataParagaphe,
  styleName,
  isConteneurDiv,
  DataParagapheDiv,
}) => {
  return (
    <section className={styleName}>
      {isConteneurDiv && (
        <div>
          {DataParagapheDiv.map((item, index) => (
            <ParagrapheSectionFacture
              styleParagraphe={item.styleParagraphe}
              key={index}
              libelle={item.libelle}
            />
          ))}
        </div>
      )}

      {!isConteneurDiv && (
        <>
          {DataParagaphe.map((item, index) => (
            <ParagrapheSectionFacture
              styleParagraphe={item.styleParagraphe}
              key={index}
              libelle={item.libelle}
            />
          ))}
        </>
      )}
    </section>
  );
};
const ShowLocataire = ({ infoForLocataireInHouse }) => {
  return (
    <ul className="px-4 m-0">
      {infoForLocataireInHouse.map((item, index) => (
        <li key={index} className="p-1 m-0" style={{ listStyleType: "circle" }}>
          {`${item.client.nom} ${item.client.prenom}`}
        </li>
      ))}
    </ul>
  );
};
const ShowCommission = ({ infoAllCommissions }) => {
  return infoAllCommissions.map(
    (item, index) =>
      item.value !== null && (
        <div
          key={index}
          className="d-flex gap-3 align-items-center flex-wrap my-1">
          <span>{item.libelle} :</span>
          <span>{Help.convertInMoney(item.value)} Fcfa</span>
        </div>
      )
  );
};
function calculeTotal(NbreMoisAvance, prix, NbreMoisCaution) {
  const loyerCaution = Number(prix) * Number(NbreMoisCaution);

  const loyerAvance = Number(prix) * Number(NbreMoisAvance);

  const fraisDossier = (Number(prix) * 10) / 100;

  return loyerCaution + loyerAvance + Number(prix) + fraisDossier;
}

export const PrintFacture = ({
  dataInfoForPrint: {
    contract: {
      client: { nom, prenom, phone },
      // propriety: { cost },
      nombre_mois_caution,
      nombre_mois_avance,
    },
    reference,
    type,
    cost,
  },
}) => {
  const printRef = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  const natureFacture = {
    loyer: true,
    Achat: true,
  };
  return (
    <>
      <div ref={printRef} className="px-4">
        <SectionFacture
          styleName={"d-flex justify-content-between align-items-center"}
          DataParagaphe={[
            {
              libelle: "REF:C/.../.../PDG/APRIM",
            },
            {
              libelle: `Abidjan, le ${dayjs().format("DD/MM/YYYY")}`,
            },
          ]}
        />
        <SectionFacture
          styleName={"d-flex justify-content-end my-5"}
          isConteneurDiv
          DataParagapheDiv={[
            {
              libelle: "A",
            },
            {
              libelle: `${nom} ${prenom}`,
            },
            {
              libelle: phone,
            },
            {
              libelle: " ABIDJAN",
            },
          ]}
        />
        <SectionFacture
          styleName={"d-flex justify-content-center"}
          DataParagaphe={[
            {
              libelle: `FACTURE PROFORM : ${reference}`,
              styleParagraphe:
                "w-50 border border-2 border-primary rounded p-2 text-center",
            },
          ]}
        />
        <SectionFacture
          styleName={"d-flex justify-content-center my-2"}
          DataParagaphe={[
            {
              libelle: ` LOCATION - TYPE DE MAISON (APPT, VILLA BASSE, VILLA DUPLEX, VILLA
              TRIPLEX, TERRAIN - NOMBRE DE PIECE OU SUPERFICIE DU TERRAIN-
              LOCALISATION DU)`,
              styleParagraphe: "border border-5 border-dark text-center px-2",
            },
          ]}
        />
        {natureFacture[type] && (
          <FactureLoyer
            cost={cost}
            nombre_mois_caution={nombre_mois_caution}
            nombre_mois_avance={nombre_mois_avance}
            calculeTotal={calculeTotal}
          />
        )}
        {type === "caution" && (
          <FactureCaution
            cost={cost}
            nombre_mois_caution={nombre_mois_caution}
            nombre_mois_avance={nombre_mois_avance}
            calculeTotal={calculeTotal}
          />
        )}

        <SectionFacture
          styleName={"d-flex justify-content-end my-5"}
          DataParagaphe={[
            {
              libelle: `TITRE DU RESPONSABLE DE L’AGENCE`,
              styleParagraphe: "h3",
            },
          ]}
        />
        <SectionFacture
          styleName={"d-flex justify-content-end my-5"}
          DataParagaphe={[
            {
              libelle: `NOM DU RESPONSABLE`,
              styleParagraphe: "h3",
            },
          ]}
        />
      </div>
      <section className="d-flex justify-content-end">
        <span>Imprimer la facture</span>
        <IoPrint
          fontSize={"2em"}
          style={{ cursor: "pointer" }}
          onClick={() => handlePrint()}
        />
      </section>
    </>
  );
};

export default function ModalDelete({
  modalTitle,
  isPrintFacture,
  dataInfoForPrint,
  dataInfoForBtn,
  isRejectedBtn,
  valueTextField,
  handleChangeRejectWithTextField,
  isInfoStatistique,
  infoStatistiqueData,
  locataireInHouse,
  infoForLocataireInHouse,
  commissionVente,
  infoAllCommissions,
  isRenouvellementContrat,
}) {
  const dispatch = useDispatch();
  const isShowModal = useSelector((state) => state.print.isShowModal);
  return (
    <div>
      <Modal
        open={isShowModal}
        onClose={() => dispatch(showModal())}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isPrintFacture ? 900 : 500,
            overflow: "auto",
            height: isPrintFacture ? 500 : "auto",
            bgcolor: "background.paper",
            border: "1px solid #000",
            boxShadow: 24,
            borderRadius: "10px",
            padding: "2em",
          }}>
          <h5>{modalTitle}</h5>
          {isRenouvellementContrat && <RenouvellementContrat />}
          {isPrintFacture && (
            <PrintFacture dataInfoForPrint={dataInfoForPrint} />
          )}
          {isInfoStatistique &&
            infoStatistiqueData.map((item, index) => (
              <div key={index}>
                <h6>
                  {item.libelle} : {Help.convertInMoney(item.value)}{" "}
                </h6>
                {/* {
                item.sousValue.length > 0 && item.sousValue.map((element,index)=>(
                  <p key={index}>{element.libelle} : {Help.convertInMoney(element.value)}</p>
                ))
              } */}
              </div>
            ))}
          {locataireInHouse && (
            <ShowLocataire infoForLocataireInHouse={infoForLocataireInHouse} />
          )}
          {commissionVente && (
            <ShowCommission infoAllCommissions={infoAllCommissions} />
          )}
          {!isPrintFacture && (
            <>
              {isRejectedBtn && (
                <InputTextarea
                  style={{ width: "100%" }}
                  placeholder="Commentaire"
                  value={valueTextField}
                  onChange={handleChangeRejectWithTextField}
                  rows={5}
                  cols={30}
                />
              )}
              <Stack
                direction="row"
                spacing={2}
                sx={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  padding: "1.5em 0",
                }}>
                {dataInfoForBtn.length > 0 &&
                  dataInfoForBtn.map((item, index) => (
                    <Button
                      key={index}
                      sx={{ background: item.isStyle ? "gray" : null }}
                      variant="contained"
                      color={item.color}
                      onClick={item.methode}>
                      {item.libelleBtn}
                    </Button>
                  ))}
              </Stack>
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
}
